function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 3.657,
  cy: 3.657,
  transform: "matrix(-1 0 0 1 11.057 1)",
  stroke: "#B0B8CE",
  strokeWidth: 1.5,
  r: 3.657
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 13.742c0-.787.494-1.488 1.235-1.753v0a15.356 15.356 0 0110.33 0v0c.74.265 1.235.966 1.235 1.753v1.203c0 1.085-.962 1.92-2.036 1.766l-.546-.078a27.002 27.002 0 00-7.636 0l-.546.078A1.784 1.784 0 011 14.945v-1.203z",
  stroke: "#B0B8CE",
  strokeWidth: 1.5
});

function SvgAcc2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 15 18",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgAcc2;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Acc2.svg
// module id = 1320
// module chunks = 10